// FMP suffixes economic event names with a bracketed period qualifier —
// "Initial Jobless Claims (Aug/22)", "Goods Trade Balance (Jul)", "GDP
// Growth Rate QoQ (Q2)" — which reads bulky and inconsistent on a dashboard
// that already says "today". This trims a TRAILING parenthesised qualifier
// only when its content is date-like: a month (abbreviated or full,
// optionally with a /day, day or year), a quarter (optionally with a year),
// or a bare year. Non-date parentheticals ("(Preliminary)", "(YoY)") and
// names without a trailing bracket are left untouched.

const MONTH =
  "(?:Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:t(?:ember)?)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?)";

const TRAILING_DATE_QUALIFIER = new RegExp(
  "\\s*\\(\\s*(?:" +
    // "Aug", "Aug/22", "Aug 22", "Aug 2026", "August/22"
    `${MONTH}(?:\\s*/\\s*\\d{1,2}|\\s+\\d{1,4})?` +
    "|" +
    // "Q2", "Q2 2026", "Q2/2026"
    "Q[1-4](?:\\s*/\\s*\\d{2,4}|\\s+\\d{2,4})?" +
    "|" +
    // "2026"
    "\\d{4}" +
    ")\\s*\\)\\s*$",
  "i"
);

export const trimEconomicEventName = (name: string): string => {
  const trimmed = name.replace(TRAILING_DATE_QUALIFIER, "").trim();
  // A name that was ONLY a qualifier keeps its original text over vanishing.
  return trimmed.length > 0 ? trimmed : name;
};
